import { useState, type FormEvent } from 'react';
import { tr } from './lib/i18n.ts';
import { errorMessage } from './lib/api.ts';
import { useSignIn } from './lib/session.ts';
import { Wallpaper } from './wallpapers/Wallpaper.tsx';

export function AuthScreen() {
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const signIn = useSignIn(mode);

  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = String(data.get('email') ?? '');
    const password = String(data.get('password') ?? '');
    signIn.mutate(mode === 'register' ? { name: String(data.get('name') ?? ''), email, password } : { email, password });
  }

  return (
    <main className="auth">
      <Wallpaper />
      <div className="auth-card">
        <div className="auth-brand">
          <img className="auth-logo" src="/brand/omnia-logo.png" alt={tr.brandFull} width={426} height={150} draggable={false} />
        </div>
        <h1>{mode === 'login' ? tr.auth.loginTitle : tr.auth.registerTitle}</h1>
        <p className="auth-tagline">{tr.auth.tagline}</p>
        <form onSubmit={submit} className="auth-form" key={mode}>
          {mode === 'register' && (
            <label className="field">
              <span>{tr.auth.name}</span>
              <input name="name" autoComplete="name" required maxLength={80} />
            </label>
          )}
          <label className="field">
            <span>{tr.auth.email}</span>
            <input name="email" type="email" autoComplete="email" required inputMode="email" />
          </label>
          <label className="field">
            <span>
              {tr.auth.password}
              {mode === 'register' && <small> · {tr.auth.passwordHint}</small>}
            </span>
            <input
              name="password"
              type="password"
              autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
              required
              minLength={mode === 'register' ? 8 : 1}
            />
          </label>
          {signIn.isError && (
            <p className="form-error" role="alert">
              {errorMessage(signIn.error)}
            </p>
          )}
          <button type="submit" className="btn btn-primary" disabled={signIn.isPending}>
            {mode === 'login' ? tr.auth.login : tr.auth.register}
          </button>
        </form>
        <button
          type="button"
          className="link-button"
          onClick={() => {
            signIn.reset();
            setMode(mode === 'login' ? 'register' : 'login');
          }}
        >
          {mode === 'login' ? tr.auth.toRegister : tr.auth.toLogin}
        </button>
      </div>
    </main>
  );
}
